import { serverFetch } from "./server";

const WORKPLACE_STORAGE_KEY = "planOnline.settings.workplace";

let runtimeSettingsPromise;

export const invalidateRuntimeSettings = () => {
  runtimeSettingsPromise = undefined;
};

export const loadRuntimeSettings = () => {
  if (!runtimeSettingsPromise) {
    runtimeSettingsPromise = serverFetch("settings/runtime")
      .then((data) => data || {})
      .catch((error) => {
        runtimeSettingsPromise = undefined;
        throw error;
      });
  }
  return runtimeSettingsPromise;
};

export const readWorkplaceSettings = () => {
  try {
    const raw = localStorage.getItem(WORKPLACE_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

export const getSetting = (settings, name, fallback = undefined) => {
  if (!settings || typeof settings !== "object") return fallback;
  const target = name.replace(/_/g, "").toLowerCase();
  const entry = Object.entries(settings).find(
    ([key]) => key.replace(/_/g, "").toLowerCase() === target
  );
  return entry?.[1] ?? fallback;
};

export const getWorkplaceNumber = (name, fallback = 0) => {
  const workplace = readWorkplaceSettings();
  const target = name.replace(/_/g, "").toLowerCase();
  const entry = Object.entries(workplace).find(
    ([key]) => key.replace(/_/g, "").toLowerCase() === target
  );
  const value = entry?.[1];
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};
